import settings from '../../../src/es6/settings'
import { searchbutton } from "../../../src/es6/searchbutton"
// import $ from 'jquery'

document.addEventListener('DOMContentLoaded', () => {
    searchbutton('.menu1__search')
    searchbutton('.menu3__btn_search')
    searchbutton('.menu1Fixed__search')
})
